import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({ providedIn: 'root' })
export class ApiDataTravelUpdateTextService {
  constructor(private _api: ApiService) {}

  get(id: number | string) {
    return this._api.get('data-travel-update-text/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('data-travel-update-text/list', data);
  }

  create(data: any) {
    return this._api.post('data-travel-update-text/create', data);
  }

  update(data: any) {
    return this._api.post('data-travel-update-text/update', data);
  }

  remove(id: number) {
    return this._api.post('data-travel-update-text/remove/id/' + id);
  }
}
